import path from "path";
import fs from "fs/promises";



const CACHE_FILE = path.join(process.cwd(), "/config/configCache.json");

export async function readCache() {
    try{
        const raw = await fs.readFile(CACHE_FILE, 'utf8');
        return JSON.parse(raw);
    }catch(e){
        console.log('readCache', e);
        return {lastFetched: 0, config: null};
    }
}

export async function writeCache(data) {
    try{
        await fs.writeFile(CACHE_FILE, JSON.stringify(data), 'utf8');
    }catch(e){
        console.log('writeCache', e);
        
    }
}

export async function clearCache() {
    await writeCache({lastFetched: 0, config: null});
}